export interface LogRetentionConfig {
    maxEntries: number;
    maxAgeMs: number;
    maxOutboxEntries?: number;
    diagnosticMode?: boolean;
}

export const DEFAULT_MAX_OUTBOX_ENTRIES = 1000;

export const defaultLogRetentionConfig: LogRetentionConfig = {
    maxEntries: 5000,
    maxAgeMs: 14 * 24 * 60 * 60 * 1000,
    maxOutboxEntries: DEFAULT_MAX_OUTBOX_ENTRIES,
    diagnosticMode: false
}
